"use client";

import { type ReactNode, useState } from "react";
import Flex from "@/shared/components/common/Flex";
import Typography from "@/shared/components/common/Typography";
import PhosphorIcon from "@/shared/components/common/PhosphorIcon";
import { cn } from "@/shared/libs/commonUtils";

interface CollapsibleCollapsibleContentProps {
  content: string | ReactNode;
  showMoreText: string;
  showLessText: string;
}

export default function CollapsibleContent({
  content,
  showMoreText,
  showLessText,
}: CollapsibleCollapsibleContentProps) {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <Flex
      className={cn(
        "relative transition-all duration-200 ease-in-out overflow-hidden pb-10 group ring-1 ring-border rounded-md",
        isOpen ? "h-auto" : "h-40 overflow-hidden",
      )}
    >
      <div className="bg-background md:shadow-1 md:ring-1 ring-border rounded md:rounded-xs max-sm:ring-[1px] p-4">
        {content}
      </div>

      <Flex
        onClick={handleToggle}
        alignItems={"center"}
        justifyContent={"center"}
        gap={"2"}
        className="w-full py-3 absolute bottom-0 left-1/2 -translate-x-1/2 bg-linear-to-t from-muted dark:from-background/80 to-background rounded-b-xs cursor-pointer"
      >
        <PhosphorIcon
          name="CaretUp"
          size={24}
          weight="regular"
          className={cn(
            isOpen ? "" : "rotate-180",
            "text-muted-foreground group-hover:text-primary transition ease-in-out duration-75",
          )}
        />
        <Typography variant={"body3"} className="text-foreground">
          {isOpen ? showLessText : showMoreText}
        </Typography>
      </Flex>
    </Flex>
  );
}
